import { Stack } from 'expo-router';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';
import { WikiChangesNpoModalProvider } from '@/contexts/wikiChangesNpoModalContext';
import WikiChangeNpoModal from '@/components/modals/WikiChangeNpoModal';

const EditLayout = () => {
  return (
    <WikiChangesNpoModalProvider>
      <PlatformContainer contentCustomClassnames="flex">
        <SafeAreaView style={style.container} edges={['bottom']}>
          <WikiChangeNpoModal />
          <Stack
            screenOptions={{
              headerShown: true,
              headerShadowVisible: false,
              headerBackVisible: false,
              headerLeft: () => <GoBackButton />,
              headerTitle: () => <Title label={i18n.t('mix.edit_title')} />,
              headerStyle: { backgroundColor: 'transparent' }
            }}>
            <Stack.Screen name="npoGeneral" />
            <Stack.Screen name="npoBioWiki" />
            <Stack.Screen name="npoRevenue" />
            <Stack.Screen name="npoRevenueWiki" />
            <Stack.Screen name="npoTotalSalaries" />
            <Stack.Screen name="npoFundraising" />
            <Stack.Screen name="npoLandEquipments" />
            <Stack.Screen name="npoBackgroundChecks" />
            <Stack.Screen name="npoSalaries" />
            <Stack.Screen name="npoBoardDirectors" />
            <Stack.Screen name="npoPastors" />
            <Stack.Screen name="npoPL" />
            <Stack.Screen name="npoPLWiki" />
            <Stack.Screen name="npoPartyAudit" />
            <Stack.Screen name="npoImpactStudy" />
            <Stack.Screen name="npoPrograms" />
            <Stack.Screen name="npoTotalGrantsPrograms" />
            <Stack.Screen name="npoVolunteerEvent" />
            <Stack.Screen name="npoLightRatingQuestions" />
            <Stack.Screen
              name="addUpdateSalary"
              options={{
                headerLeft: () => <GoBackButton navigateTo={'/edit/npoSalaries'} />,
                headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.salaries.title')} />
              }}
            />
            <Stack.Screen
              name="addUpdateDirector"
              options={{
                headerLeft: () => <GoBackButton navigateTo={'/edit/npoBoardDirectors'} />,
                headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.board_directors.individual_title')} />
              }}
            />
            <Stack.Screen
              name="addUpdatePastor"
              options={{
                headerLeft: () => <GoBackButton navigateTo={'/edit/npoPastors'} />,
                headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.pastors.individual_title')} />
              }}
            />
            <Stack.Screen
              name="addUpdateProgram"
              options={{
                headerLeft: () => <GoBackButton navigateTo={'/edit/npoPrograms'} />,
                headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.programs.individual_title')} />
              }}
            />
            <Stack.Screen
              name="addUpdateTotalGrantProgram"
              options={{
                headerLeft: () => <GoBackButton navigateTo={'/edit/npoTotalGrantsPrograms'} />,
                headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.total_grants_programs.individual_title')} />
              }}
            />
            <Stack.Screen name="editOneProgram" />
          </Stack>
        </SafeAreaView>
      </PlatformContainer>
    </WikiChangesNpoModalProvider>
  );
};

const style = StyleSheet.create({
  container: {
    flex: 1
  }
});

export default EditLayout;
